<div *ngIf="!productDataShow"
	 class="w-full flex justify-center items-center">
	<section class="container w-full flex flex-col gap-2 justify-center items-center min-h-[50vh]">
		<img class="w-[80px] animate-bounce" src="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/logo_black.svg" alt="Anuprerna">
		<p class="text-3xl mb-5 animate-bounce">Anuprerna</p>
		<mat-progress-spinner mode="indeterminate"
							  color="primary"
							  diameter="30"></mat-progress-spinner>
	</section>

</div>
<div class="cus_con_wrapper" *ngIf="productDataShow">
	<div class="page-container cus_cont">
		<div class="product_details_container_outer"
			style="background-image: url(./assets/img/tempnavmotif_top_open.svg);">
			<div class="image_container">
				<fb-product-image [dataVideo]="productData.productVideo!"
								  [product]="productData"
								  [dataProductImageAddOn]="addOnImage">
				</fb-product-image>
			</div>
			<div class="product_details_container">
				<div class="product_details_container_inner">
					<fb-product-basic-info [dataProductBasicInfo]="productData"></fb-product-basic-info>

					<fb-bulk-login-and-share-and-addtostoryboard-container (openVolumeDiscount)="openVolumeDiscount()"
																		   [product]="productData"
																		   *ngIf="productData.volumeDiscountProfileEnabled">
					</fb-bulk-login-and-share-and-addtostoryboard-container>
					<div *ngIf="!isTheOrderInStock && !isCartDisable"
						 (click)="onMadeToOrderClick()"
						 class="f-mto">
						Made To Order
						<span class="close material-symbols-outlined info_icon text-xs">info</span>
					</div>
					<div class="flex items-center gap-1 cursor-pointer" (click)="onOverallReviewClick()">
						<span *ngFor="let _ of stars; let i = index">
							<span class="star" [class.filled]="rating > i">&#9733;</span>
						</span>
						<span>({{reviewCount}})</span>
					</div>
					<fb-choose-color [dataColor]="productData.relatedProductList" [productId]="productData.id">
					</fb-choose-color>
					<fb-gsm-and-weight [dataGsm]="wholeResponse"></fb-gsm-and-weight>
					<div class="customizeTrigger" (click)="triggerCustomizeOption()"
					*ngIf="productData.fabricProfileEnabled
					|| productData.sizeProfileEnabled
					|| productData.finishProfileEnabled ">
							<button class="
						{{isCusomizationOpen?'active':''}}
						{{isAnimationStopped?'animtion_stopped':''}}">
								<span>Customise {{isThisProductFabric?'This Fabric':'This Product'}}</span>
								<span class="material-symbols-outlined expand">expand_more</span>
							</button>
						</div>
						<div class="customization_container {{isCusomizationOpen?'active':''}}">
							<fb-choose-fabric *ngIf="productData.fabricProfileEnabled && triggerCartClose"
											  [fabricData]="productData"
											  (imageTransferDisplayImage)="updateImageToDisplay($event)">
							</fb-choose-fabric>
							<ng-container *ngIf="productData.sizeProfileEnabled && triggerCartClose">
								<fb-choose-size [sizeData]="productData.sizeProfile!"
												[customSizeData]="productData.customSizeProfile!"
												[customSizeDataEnabled]="productData.customSizeProfileEnabled"
												[productSizeProfileList]="productData.productSizeProfileList!"
												[product]="productData"
												(passQuantity)="updateQuantity($event)"
												*ngIf="reload"></fb-choose-size>
							</ng-container>
							<ng-container *ngIf="isFinishShow">
								<fb-select-finish *ngIf="productData.finishProfileEnabled && productData.finishProfile && isFinishShow"
												  [finishProfileData]="productData.finishProfile!"
												  [productId]="productData.id"
												  [madeToOrderFabricId]="productData.madeToOrderFabric?.id"
												  [instockIds]="productData.finishProfileItemId"></fb-select-finish>
							</ng-container>
						</div>

					<fb-order-quantity [totalQuantityFromParent]="productData.totalQuantity"
									   [unitFromParent]="productData.unit"
									   [productData]="productData"
									   (sendQtyToCartButton)="passQtyToCartButton($event)"></fb-order-quantity>

					<fb-cart-buttons *ngIf="triggerCartClose"
									 [productData]="productData"
									 [itemInStock]="itemInStockForPass"
									 [addToSwatch]="wholeResponse.addToSwatch"
									 (triggerOpenPreOrder)="preOrderOpen()">
					</fb-cart-buttons>
					<div class="h-1 opacity-0" #estimated></div>
					<fb-volume-discount *ngIf="isVolumeDiscountClose"
					[unit]="productData.unit"
						[dataVolumeDiscount]="productData.volumeDiscountProfile!"
						(closeVolumeDiscountOption)="isVolumeDiscountClose = false; _globalService.popUpOpenClose(false);">
					</fb-volume-discount>
					<fb-badge-profile [dataBadgeProfile]="productData.badgeProfile!"
									  *ngIf="productData.badgeProfileEnabled"></fb-badge-profile>
					<div class="accordion_product_details_outer">
						<fb-product-accordion [dataAccordion]="productData" [dataGsm]="wholeResponse">
						</fb-product-accordion>
					</div>
				</div>
				<div class="pre_order_container" *ngIf="isPreOrderPopOpen">
					<button class="close_preorder">
						<span class="material-symbols-outlined" (click)="preOrderClose(true)">
							close
						</span>
					</button>
					<fb-pre-order *ngIf="productData" [productData]="productData"
						(imageTransfetDisplayImage)="updateImageToDisplay($event)"
						(preOrderClose)="preOrderClose()" style="width:100%;"></fb-pre-order>
				</div>
			</div>
		</div>
		<div class="flex flex-col items-center">
			<h1 class="text-xl sm:text-3xl text-[#7D5B20] font-medium lg:px-10 mb-2" #reviewSection>
				Hear from our <span class="text-black">Customers</span>
			</h1>
			<fb-review-list class="w-full" [productId]="productData.id"></fb-review-list>
		</div>
	</div>
	<fb-content-slider *ngIf="isStoryListVisible"></fb-content-slider>
</div>


